import script from "./current.vue?vue&type=script&setup=true&lang=js"
export * from "./current.vue?vue&type=script&setup=true&lang=js"

import "./current.vue?vue&type=style&index=0&id=83db169c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83db169c"]])

export default __exports__